import { PROMPTS } from "../data/prompts";
import { PromptCard } from "./PromptCard";

export function PromptTicker() {
  return (
    <div
      className="bg-transparent"
      role="presentation"
      aria-label="Sample prompts from Photobomb"
    >
      <div className="overflow-hidden py-4 sm:py-5 md:py-6">
        <div className="prompt-ticker-track landing-sans-copy flex w-max flex-nowrap items-center gap-3 sm:gap-4 md:gap-5">
          {PROMPTS.map((text, i) => (
            <PromptCard
              key={`t1-${i}`}
              text={text}
              compact
              className="max-w-[min(100%,12rem)] shrink-0 shadow-md sm:max-w-[14rem]"
            />
          ))}
          {PROMPTS.map((text, i) => (
            <PromptCard
              key={`t2-${i}`}
              text={text}
              compact
              className="max-w-[min(100%,12rem)] shrink-0 shadow-md sm:max-w-[14rem]"
              aria-hidden={true}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
